/** 24h HH:MM — 수업시간·알람 등 오전/오후 표시용 */

export function parseHHMM(hhmm: string): { hour24: number; minute: number } | null {
  const m = /^([01]\d|2[0-3]):([0-5]\d)$/.exec(hhmm.trim());
  if (!m) return null;
  return { hour24: parseInt(m[1], 10), minute: parseInt(m[2], 10) };
}

export function toHHMM(hour24: number, minute: number): string {
  const h = ((hour24 % 24) + 24) % 24;
  const m = ((minute % 60) + 60) % 60;
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
}

export function hour24ToParts(hour24: number): { isPm: boolean; hour12: number } {
  const isPm = hour24 >= 12;
  const hour12 = hour24 % 12 || 12;
  return { isPm, hour12 };
}

export function partsToHour24(isPm: boolean, hour12: number): number {
  const h = Math.min(12, Math.max(1, hour12));
  if (!isPm) return h === 12 ? 0 : h;
  return h === 12 ? 12 : h + 12;
}

export function formatEduTimeDisplay(hhmm: string): { period: string; clock: string } | null {
  const parsed = parseHHMM(hhmm);
  if (!parsed) return null;
  const { isPm, hour12 } = hour24ToParts(parsed.hour24);
  return {
    period: isPm ? '오후' : '오전',
    clock: `${String(hour12).padStart(2, '0')}:${String(parsed.minute).padStart(2, '0')}`,
  };
}

export const EDU_TIME_HOUR12_OPTIONS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12] as const;

export const EDU_TIME_MINUTE5_OPTIONS = Array.from({ length: 12 }, (_, i) => i * 5);

export function snapMinuteTo5(minute: number): number {
  return Math.min(55, Math.round(minute / 5) * 5);
}

export function nearestMinute5Option(minute: number): number {
  return EDU_TIME_MINUTE5_OPTIONS.reduce((best, opt) =>
    Math.abs(opt - minute) < Math.abs(best - minute) ? opt : best
  );
}

/** 분을 5분 단위로 ±step (시각 경계 넘으면 시도 함께 이동) */
export function stepTimeByMinutes(
  hour24: number,
  minute: number,
  deltaMinutes: number
): { hour24: number; minute: number } {
  let total = hour24 * 60 + minute + deltaMinutes;
  total = ((total % 1440) + 1440) % 1440;
  return { hour24: Math.floor(total / 60), minute: total % 60 };
}

export function stepTimeByFiveMinutes(
  hour24: number,
  minute: number,
  direction: 1 | -1
): { hour24: number; minute: number } {
  const baseMinute = snapMinuteTo5(minute);
  return stepTimeByMinutes(hour24, baseMinute, direction * 5);
}
